
export class DynamicOptCatalog {
    queryableTables: any[];
    comparers: any[];
    combiners: any[];
}
